  <ul class="nav flex-column">

    <li class="nav-item">
        <a routerLink="/teacher/quiz" class="btn btn-light btntab"><i class="fa fa-list" aria-hidden="true"></i> Quiz Battle</a>
        <!-- <a routerLink="/teacher" class="btn btn-light btntab">Student Test</a> -->
        <!-- <a routerLink="/teacher" class="btn btn-light btntab">ข้อมูลการสมัคร</a> -->
    </li>

  </ul>